import { FormHelperText } from '@mui/material';
import { FieldError } from 'react-hook-form';

interface FieldErrorMessageProps {
  error: FieldError | undefined;
  show: boolean;
}

function FieldErrorMessage(props: FieldErrorMessageProps) {
  const { error, show } = props;

  return show ? (
    <FormHelperText role='alert' error>
      {error?.message}
    </FormHelperText>
  ) : null;
}

export default FieldErrorMessage;
